<template>
  <RevButton
    data-qa="go-to-select-your-orderline"
    data-test="go-to-select-your-orderline"
    full-width="adaptive"
    :to="selectYourOrderlineRoute"
    :variant
  >
    {{ i18n(translations.label) }}
  </RevButton>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevButton } from '@ds/components/Button'

import { ROUTE_NAMES } from '@/scopes/dashboard/constants'

import translations from './GoToSelectYourOrderlineAction.translations'
import type { GoToSelectYourOrderlineActionProps } from './GoToSelectYourOrderlineAction.types'

const { variant = 'secondary', orderlinePublicId } =
  defineProps<GoToSelectYourOrderlineActionProps>()

const i18n = useI18n()
const injectLocale = useRouteLocationWithLocale()

const selectYourOrderlineRoute = toNuxtLink(
  injectLocale({
    type: 'internal',
    name: ROUTE_NAMES.DASHBOARD.MY_ORDERS.SELECT_YOUR_ORDERLINE,
    params: {
      orderlinePublicId,
    },
  }),
)
</script>
